import { render, staticRenderFns } from "./ModalAnaliseElegibilidade.vue?vue&type=template&id=4c135b78&lang=pug"
import script from "./ModalAnaliseElegibilidade.vue?vue&type=script&lang=js"
export * from "./ModalAnaliseElegibilidade.vue?vue&type=script&lang=js"
import style0 from "./ModalAnaliseElegibilidade.vue?vue&type=style&index=0&id=4c135b78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports